import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OrdnerEnum} from '../../core/model/ordner.enum';
import {NachrichtenOrdner} from '../../core/model/nachrichten-ordner';
import {I18NextPipe} from "@kokos-i18next";

@Component({
    selector: 'kokos-postfach-folder-list',
    imports: [
        I18NextPipe
    ],
    templateUrl: './postfach-folder-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class PostfachFolderListComponent {

    @Input() selectedFolder = OrdnerEnum.ERHALTEN;
    @Input() nachrichtFolders: NachrichtenOrdner[] = [];

    @Output() folderSelected = new EventEmitter<OrdnerEnum>();

    ordnerEnum = OrdnerEnum;

    getFolderClassList(folder: OrdnerEnum): string {
        return 'ba-icon m-0 d-flex ' + (this.selectedFolder === folder ? 'font-bold active' : '');
    }

    onFolderSelected(selectedFolder: OrdnerEnum, event: MouseEvent): void {
        event.preventDefault();
        this.folderSelected.emit(selectedFolder);
    }

    getNachrichtFolder(ordnerEnum: OrdnerEnum): NachrichtenOrdner {
        return this.nachrichtFolders?.find((folder: NachrichtenOrdner) => folder.name === ordnerEnum);
    }

}
